"use client";
import { leaders } from "@/utils/leadershipInfo";
import { useParams, useRouter } from "next/navigation";
import ProfileHeader from "@/components/about/leaders/leader-profile/Header";
import ProfileInfo from "@/components/about/leaders/leader-profile/ProfileInfo";
import ProfileQuote from "@/components/about/leaders/leader-profile/Quote";
import { navigateWithQueryParams } from "@/utils/navigationUtils";
import Footer from "@/components/Footer";

export default function Content() {
  const router = useRouter();
  const params = useParams();

  const slug = params?.slug as string;
  const leader = leaders[slug];

  if (!leader) {
    navigateWithQueryParams(router, "/about/leaders");
    return null;
  }

  return (
    <div className="min-h-screen bg-background">
      <main>
        <ProfileHeader name={leader.name} title={leader.title} />
        <ProfileInfo leader={leader} />
        <ProfileQuote quote={leader.quote} author={leader.quoteAuthor} />
      </main>
      <Footer />
    </div>
  );
}
